import findKey from 'lodash/findKey';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';

type PlotColourLookup = Record<
  string,
  {
    color: string;
    columnName: string;
    id: number;
    shortName: string;
    longName: string;
  }
>;

export const CompensationResponseLevelOverrides = {
  msa: 'metro_area',
};

const _plotColorLookup: PlotColourLookup = {};

export const getPlotColorByKey = (key: string): string | undefined => {
  const entry = _plotColorLookup[key];
  return entry?.color;
};

export const getColorKeyByIdAndName = (
  id: number | string,
  shortName: string,
  longName: string
) => {
  const [selectionList, numericalId] = id?.toString().split('__') || [];

  const builtKey = `${selectionList}__${numericalId}`;

  const directMatch = get(_plotColorLookup, builtKey);

  if (directMatch) {
    return builtKey;
  }

  const colorKey = findKey(_plotColorLookup, (item) => {
    const {
      id: itemId,
      columnName,
      shortName: itemShortName,
      longName: itemLongName,
    } = item;

    const comparisonId = `${columnName}__${itemId}`;

    const idMatch =
      id === comparisonId || id == itemId || numericalId === itemId?.toString();

    //catches `London (United Kingdom)` when searching for `London`
    const labelMatch =
      itemLongName?.includes(longName) || itemShortName?.includes(shortName);

    return idMatch && labelMatch;
  });

  return colorKey;
};

interface KeyValuePair {
  [key: string]: unknown;
}

interface GetColorKeyFromLookupProps {
  metadata: KeyValuePair & { shortName: string; longName: string };
  d: KeyValuePair;
  colorLookupKeyPath: string;
}

export const getColorKeyFromLookup = ({
  metadata,
  d,
  colorLookupKeyPath,
}: GetColorKeyFromLookupProps) => {
  const { type } = metadata;

  if (isUndefined(type)) {
    const { id, shortName, longName } = metadata;

    if (isUndefined(id)) {
      return getColorKeyByIdAndName(
        get(d, 'id', '') as string,
        shortName,
        longName
      );
    }

    return getColorKeyByIdAndName(id as number | string, shortName, longName);
  }

  return `${String(type).toLowerCase()}__${get(d, colorLookupKeyPath)}`;
};
